import Bugsnag from '@bugsnag/browser';
import { errorify } from '@calefy-inc/utility';

export const logicConditionTrue = ({
  sourceValue,
  operator,
  not,
  condition,
}: {
  sourceValue: string;
  operator: string;
  not: boolean;
  condition: string;
}): boolean => {
  let result = false;
  try {
    if (sourceValue) {
      switch (operator) {
        case 'equals':
          result =
            sourceValue === condition ||
            // @ts-expect-error
            (condition === 'true' && sourceValue === true);
          break;
        case 'greater':
          result = Number(sourceValue) > Number(condition);
          break;
        case 'geq':
          result = Number(sourceValue) >= Number(condition);
          break;
        case 'lesser':
          result = Number(sourceValue) < Number(condition);
          break;
        case 'leq':
          result = Number(sourceValue) <= Number(condition);
          break;
        case 'contains':
          result =
            typeof sourceValue === 'string' &&
            sourceValue !== 'N/A' &&
            sourceValue.includes(condition);
          break;
      }
      if (not) {
        result = !result;
      }
    }
  } catch (e) {
    console.error(e);
    Bugsnag.notify(errorify(e));
  }
  return result;
};
